<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
  <v-content> 
    <div class="block">
      <v-container>
        <v-row>
          <v-col v-for="item in items" :key="item.id" class="d-flex child-flex" cols="12" sm="6" md="4">
            <v-card  class="mx-auto custom-card" color="#25262D">
              <a :href=item.web >
                <v-img :src="item.src" aspect-ratio="1" class="grey lighten-2"></v-img>
                <v-card-text class="text--primary diagonal-top">
                  <div class="title" style="color:white; font-weight: 600; text-transform: uppercase;">{{ item.name }}</div>
                  <p style="color:white">{{ item.title }}</p>
                </v-card-text>
              </a>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-content>
</template>

<script>

export default {
  name: "About",
  data() {
    return {
      items: [
        {
          id: 1,
          src: require("../assets/team/manel.jpeg"),
          name: 'Manel Mena',
          title: 'Main developer and maintainer of WoT Remote Lab.',
          web: 'https://acg.ual.es/en/members/manel-mena/'
        },
        {
          id: 2,
          src: require("../assets/team/juan.jpeg"),
          name: 'Juan Alberto Llopis',
          title: 'Main developer of the WoT Remote Lab Discovery Service.',
          web: 'https://acg.ual.es/en/members/juan-a-llopis/'
        },
        {
          id: 3,
          src: require("../assets/team/javi.jpg"),
          name: 'Javier Criado',
          title: 'The Boss',
          web: 'https://acg.ual.es/en/members/javier-criado/'
        },
        {
          id: 4,
          src: require("../assets/team/luis.jpg"),
          name: 'Luis Iribarne',
          title: 'The Boss Boss',
          web: 'https://acg.ual.es/en/members/luis-iribarne/'
        }
      ]
    };
  }
};
</script>
<style scoped>
.custom-card {
  max-width: 85%;
}

.diagonal-top {
  position: relative;
  padding-top: 20px;
  z-index: 1;
}

.diagonal-top::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #25262D;
  transform: skewY(-5deg);
  transform-origin: bottom left;
  z-index: -1;
}

.title, p {
  position: relative;
  z-index: 1;
}

@media (max-width: 600px) {
  .diagonal-top {
    padding-top: 20px;
  }

  .diagonal-top::before {
    height: 100%;
    top: -20px;
  }
}
</style>